import Media from './../mediaDetect.js'; //Детектор медиа
import Twig from 'twig';
import Calendar from './../components/calendar.js';
import LiveSearch from './../components/live-search.js';

/*
 * Скрипты для страницы Календарь мероприятий
*/

let langId = window.langId;
let EventsFilter = {
    search: '',
    typeEvent: '',
    dateStart: '', // глобальная дата, которая передаётся в качестве параметра фильтрации
    dateFinish: '' // глобальная дата, которая передаётся в качестве параметра фильтрации
}

let isClearSearchCalendar = true,
    currEventsListPage = 1,
    currParamsUrs = '', // хранит параметры урла - интервал дат и тип мероприятия
    isClickClearWithParams = false,
    timeoutAjaxFilterEvents,
    delayAjaxFilterEvents = 350;

let EventsLiveSearchOptions = {};

let Events = {
    initSearch: function(){

        let btnClearSearchCalendar = $('[data-clear-search-calendar-filter]');
        if(btnClearSearchCalendar.length){
            btnClearSearchCalendar.on('click', function(){
                // Очищаем поле поиска
                Events.clearSearch();
                // Если изменилось значение поля поиска, то сбрасываем текущую страницу на 1
                currEventsListPage = 1;
                // Обновляем список мероприятий
                EventsFilter.clearSearchText = 'Y';
                Events.ajaxFilter();
                setTimeout(function(){
                    EventsFilter.clearSearchText = '';
                }, delayAjaxFilterEvents);
            });
        }

        let inputSearchCalendar = $('[data-input-search-calendar-filter]');
        inputSearchCalendar.on('blur', function(){
            if($(this).val() == ''){
                btnClearSearchCalendar.removeClass('show');
            }else{
                btnClearSearchCalendar.addClass('show');
            }
            Events.setDataForSearch($(this));
            Events.ajaxFilter();
        });

        // По клику на иконку поиска, обновляем список мероприятий
        let btnSearchCalendar = $('[data-btn-search-calendar-filter]');
        if(btnSearchCalendar.length) {
            btnSearchCalendar.on('click', function(){
                Events.setDataForSearch(inputSearchCalendar);
            });
        }

        // По клавише enter, обновляем список мероприятий с учётом поля поиска
        let calendarSearchForm = $('[data-calendar-search-form]');
        if(calendarSearchForm.length) {
            calendarSearchForm.on('submit', function(e){
                e.preventDefault();
                Events.setDataForSearch(inputSearchCalendar);
            });
        }
    },
    initSelect: function(elem){
        // Если при загрузке страницы в дата-атрибуте data-loaddate-type-event-calendar есть номер выбранного значения,
        // то записываем его в переменную фильтра EventsFilter.typeEvent
        let valLoaddateTypeEventCalendar = $('[data-loaddate-type-event-calendar]').data('loaddate-type-event-calendar');
        EventsFilter.typeEvent = valLoaddateTypeEventCalendar;

        if(valLoaddateTypeEventCalendar != '') {
            $('[data-clear-filter-calendar-events]').addClass('show');
        }

        elem.selectize({
            onChange: function(value){
                var elem = this.$input[0],
                    container = $(elem).closest('[data-select-calendar-filter-events-wrap]');

                // fix бага selectize с выбранным элементом
                container.find('.option').removeClass('selected');
                container.find('[data-value="'+value+'"].option').addClass('selected');

                // Обновляем список мероприятий
                if(isClearSearchCalendar) {
                    Events.clearSearch();
                    EventsFilter.clearSearchText = 'Y';
                }
                isClearSearchCalendar = true;
                EventsFilter.typeEvent = $(elem).val();

                // Если изменилось значение в селекте, то сбрасываем текущую страницу на 1
                currEventsListPage = 1;

                if(($(elem).val() != '')&&($(elem).val() != '0')){
                    $('[data-clear-filter-calendar-events]').addClass('show');
                }
                Events.ajaxFilter();
                setTimeout(function(){
                    EventsFilter.clearSearchText = '';
                }, delayAjaxFilterEvents);
            },
            onInitialize: function (value) {
                this.$dropdown.css('visibility', 'hidden').css('opacity', '0');
            },
            onDropdownOpen: function (dropdown) {
                var self = this;

                $(dropdown)
                  .css('width', this.$control[0].offsetWidth + 'px')
                  .css('top', this.$control[0].offsetHeight + 'px')
                  .css('visibility', 'visible')
                  .css('opacity', '1');

                $(dropdown).addClass('has-scrollbar');
                $(dropdown).find('.selectize-dropdown-content').addClass('nano-content');

                setTimeout(function(){
                    $(dropdown).nanoScroller({scroll: 'top'});
                    self.$dropdown[0].nanoscroller.reset();
                }, 100);
            },
            onDropdownClose: function (dropdown) {
                $(dropdown).css('visibility', 'hidden').css('opacity', '0');

                setTimeout(function () {
                    $(dropdown).prev().find('input').blur();
                }, 250);
            },
        });
    },
    clearSearch: function(){
        EventsFilter.search = '';
        $('[data-input-search-calendar-filter]').val('');
        $('[data-clear-search-calendar-filter]').removeClass('show');
    },
    getJsonFromUrl: function(){
      var query = location.search.substr(1);
      var result = {};
      query.split("&").forEach(function(part) {
        var item = part.split("=");
        result[item[0]] = decodeURIComponent(item[1]);
      });
      return result;
    },
    setDataForSearch: function(searchField){
        // Устанавливаем значение для глобального параметра фильтрации
        EventsFilter.search = searchField.val();

        // Очищаем параметры фильтрации для поля даты
        Calendar.clearCalendar();
        $('[data-clear-filter-calendar-events]').removeClass('show');

        // Устанавливаем для типа мероприятия дефолтное значение, а при изменении значения
        // запускается аякс фильтрации
        isClearSearchCalendar = false;
        let selectCalendar = $('[data-select-calendar-filter-events]');

        if (selectCalendar.length){
            let optionsSelectizeTypeEvent = selectCalendar.selectize()[0].selectize.options;
            for (var key in optionsSelectizeTypeEvent) {
                var firstOptionValue = optionsSelectizeTypeEvent[key].value;
                selectCalendar.selectize()[0].selectize.setValue(firstOptionValue);
                return;
            }
        }
    },
    ajaxFilter: function(isSetPage){
        clearTimeout(timeoutAjaxFilterEvents);
        timeoutAjaxFilterEvents = setTimeout(function () {

        var paramsUrl = Events.getJsonFromUrl(),
            _page = 1;

        if((currParamsUrs.length > 0) && paramsUrl['PAGEN_1']) {
            if(isSetPage) {
                _page = parseFloat(paramsUrl['PAGEN_1']);
            }
        }

        // Переменную EventsFilter можно передать в качестве параметров аякса.
        // Она содержит все текущие значения фильтра
        $.ajax({
            url: '/'+window.langId+'/ajax/calendar-filter.php',
            data: {
                data: EventsFilter,
                page: _page
            },
            dataType: 'json',
            beforeSend: function(){},
            success: function(_data){

                let list = $('[data-calendar-list]'),
                    btn = $('[data-show-more-calendar]');

                btn.data('show-more-calendar', 1);

                if(_data.NAV_RESULT.pageCount > 1){
                    btn.show();
                }else {
                    btn.hide();
                }

                if(typeof(_data.list) !== "undefined") {
                  if (_data.list.length > 0) {
                    list.empty();

                    var template = Events.templateItemCalendar();

                    _data.list.forEach(function(section, i) {
                      list.append(template.render({
                        data : {
                          addToCalendar: _data.addToCalendar,
                          month : section.month,
                          list  : section.list,
                        }
                      }));
                    });
                  } else {
                    list.html(_data.emptyMsg);
                  }
                }

                let pagination = $('.calendar-list__pagination');
                pagination.find('.pagination').remove();
                if(_data.NAV_RESULT.NavPageCount > 1){
                    var templatePagination = Events.templatePaginationCalendar();
                    pagination.append(templatePagination.render({
                        data: {
                          navNum: _data.NAV_RESULT.NavNum,
                          currentPage: _data.NAV_RESULT.NavPageNomer,
                          strOf: _data.NAV_RESULT.strOf,
                          countAllPage: _data.NAV_RESULT.NavPageCount,
                          listUrl: _data.NAV_RESULT.strListUrl,
                          currParamsUrs: currParamsUrs
                        }
                    }));
                }

                if(isClickClearWithParams == true) {
                    isClickClearWithParams = false;
                    $('[data-content-calendar]').removeClass('filter');
                    window.location.href = window.location.pathname;
                }
            }
        });

        }, delayAjaxFilterEvents);
    },
    ajaxAddPage: function(btn){

        var calendarUrl;
        var params = {};
        if ($('[data-ui-show-more]').length) {
            calendarUrl = '/' + window.langId + '/ajax/ui-filter.php';
            var page = 'PAGEN_' + $('[data-ui-show-more]').data('nav');
            params[page] = currEventsListPage + 1;
            params['code'] = $('[data-ui-show-more]').data('code');

        } else {

            if(btn.data('show-more-type')) {
                calendarUrl = '/' + window.langId + '/ajax/' + btn.data('show-more-type') + '.php';
            } else {
                calendarUrl = '/' + window.langId + '/ajax/calendar-filter.php';
            }

            var calendarDateVal = Calendar.getCalendarFilter();
            EventsFilter.dateStart = calendarDateVal.dateStart;
            EventsFilter.dateFinish = calendarDateVal.dateFinish;

            params = {
                data: EventsFilter,
                page: currEventsListPage + 1
            };
        }

        $.ajax({
            url: calendarUrl,
            data: params,
            dataType: 'json',
            beforeSend: function(){},
            success: function(_data){
                let list = $('[data-calendar-list]'),
                    lastItem = list.find('[data-item-calendar-list]').last(),
                    lastMonthItem = lastItem.find('[data-month-calendar-list]').text();

                currEventsListPage++;

                if(currEventsListPage >= _data.NAV_RESULT.pageCount){
                    btn.hide();
                }

                if(_data.list.length > 0){
                    _data.list.forEach(function(section, i){
                        if(section.month == lastMonthItem) {
                            var template = Twig.twig({
                                data:   Events.templateSublistItemCalendar()
                            });

                            lastItem.find('[data-sublist-calendar-list]').append(template.render({
                                data: {
                                    addToCalendar: _data.addToCalendar,
                                    list: section.list,
                                }
                            }));

                        }else{
                            var template = Events.templateItemCalendar();

                            list.append(template.render({
                                data: {
                                    addToCalendar: _data.addToCalendar,
                                    month: section.month,
                                    list: section.list,
                                }
                            }));
                        }
                    });

                    let pagination = $('.calendar-list__pagination');
                    pagination.find('.pagination').remove();
                }

                let pagination = $('.calendar-list__pagination');
                pagination.find('.pagination').remove();
                if(_data.NAV_RESULT.NavPageCount > 1){
                    var templatePagination = Events.templatePaginationCalendar();
                    pagination.append(templatePagination.render({
                        data: {
                            navNum: _data.NAV_RESULT.NavNum,
                            currentPage: _data.NAV_RESULT.NavPageNomer,
                            strOf: _data.NAV_RESULT.strOf,
                            countAllPage: _data.NAV_RESULT.NavPageCount,
                            listUrl: _data.NAV_RESULT.strListUrl,
                            currParamsUrs: currParamsUrs
                        }
                    }));
                }

                let curLoc = window.location.href.slice(0,window.location.href.indexOf('\?'));
                history.pushState(null, null, curLoc + '?AJAX_RELOAD=Y&PAGEN_1=' + _data.NAV_RESULT.NavPageNomer);
            }
        });
    },
    templateItemCalendar: function(){
        var sublist = Events.templateSublistItemCalendar();
        var template = Twig.twig({
                data:   '<div class="item" data-item-calendar-list="true">'+
                            '<h2 class="item__month upper" data-month-calendar-list="true">{{ data.month|raw }}</h2>'+
                            '<div class="item__list" data-sublist-calendar-list="true">'+
                                sublist +
                            '</div>'+
                        '</div>'
            });

        return template;
    },
    templateSublistItemCalendar: function(){
        var template =  '{% for item in data.list %}'+
                            '<div class="event-card-full {{(item.isOwnExhibition ? \'event-card-full__own-exhibition\')}}" data-full-event-card="true">'+
                                '<div class="row" data-full-event-card-content="true">'+
                                    '<div class="event-card-full__top col-12 d-block d-md-none">'+
                                        '<a href="{{item.link}}" class="event-card-full__date">'+
                                            '{{item.dateInterval|raw}}'+
                                        '</a>'+
                                        '{% if item.addCalendarLink|length %}'+
                                            '<a href="{{item.addCalendarLink}}" class="event-card-full__add-calendar">'+
                                                '<span class="svg-icon">'+
                                                    '<svg>'+
                                                        '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-calendar"></use>'+
                                                    '</svg>'+
                                                '</span>'+
                                            '</a>'+
                                        '{% endif %}'+
                                    '</div>'+
                                    '<div class="col-12 col-md-2">'+
                                        '{% if item.logo|length %}'+
                                            '<a href="{{item.link}}" class="event-card-full__logo">'+
                                                '<img src="{{item.logo}}" />'+
                                            '</a>'+
                                        '{% endif %}'+
                                    '</div>'+
                                    '<div class="col-12 col-md-6 col-lg-7">'+
                                        '<a href="{{item.link}}" class="event-card-full__content">'+
                                            '<div class="event-card-full__type">{{item.type|raw}}</div>'+
                                            '<div class="event-card-full__title">{{item.title|raw}}</div>'+
                                            '<div class="event-card-full__descr">{{item.descr|raw}}</div>'+
                                            '<div class="event-card-full__info">' +
                                                '<div class="event-card-full__organizer">'+
                                                    '<div class="event-card-full__organizer-title">{{item.organizerTitle|raw}}:</div>'+
                                                    '<div class="event-card-full__organizer-name">{{item.organizer|raw}}</div>'+
                                                '</div>'+
                                                '{% if item.ageRestriction|length %}'+
                                                '<div class="event-card-full__age-restriction">' +
                                                    '{{item.ageRestriction}}' +
                                                '</div>'+
                                                '{% endif %}'+
                                            '</div>'+
                                        '</a>'+
                                    '</div>'+
                                    '<div class="col-12 col-md-4 col-lg-3 d-none d-md-block">'+
                                        '<a href="{{item.link}}" class="event-card-full__date">'+
                                            '{{item.dateInterval|raw}}'+
                                        '</a>'+
                                        '{% if item.addCalendarLink|length %}'+
                                            '<a href="{{item.addCalendarLink}}" class="event-card-full__add-calendar">'+
                                                '<span class="svg-icon">'+
                                                    '<svg>'+
                                                        '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-calendar"></use>'+
                                                    '</svg>'+
                                                '</span>'+
                                                '<span class="text">{{ data.addToCalendar }}</span>'+
                                            '</a>'+
                                        '{% endif %}'+
                                        '{% if item.place|length %}'+
                                            '<a href="{{item.link}}" class="event-card-full__place">'+
                                                '<span class="svg-icon">'+
                                                    '<svg>'+
                                                        '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-pin"></use>'+
                                                    '</svg>'+
                                                '</span>'+
                                                '<span class="text">{{item.place|raw}}</span>'+
                                            '</a>'+
                                        '{% endif %}'+
                                        '{% if item.dateRemains|length %}'+
                                            '<a href="{{item.link}}" class="event-card-full__remains">'+
                                                '{{item.dateRemains|raw}}'+
                                            '</a>'+
                                        '{% endif %}'+
                                    '</div>'+
                                '</div>'+
                            '</div>'+
                        '{% endfor %}';

        return template;
    },
    templatePaginationCalendar: function(){
        var template = Twig.twig({
                data: '<div class="pagination">'+
                            '{% if data.currentPage == 1 %}'+
                                '<div class="pagination__prev disabled">'+
                                    '<span class="svg-icon">'+
                                        '<svg>'+
                                            '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow-right"></use>'+
                                        '</svg>'+
                                    '</span>'+
                                '</div>'+
                            '{% else %}'+
                                '<a href="?PAGEN_{{ data.navNum }}={{  data.currentPage - 1 }}{{  data.currParamsUrs }}" class="pagination__prev" data-prev-calendar-pagination="true">'+
                                    '<span class="svg-icon">'+
                                        '<svg>'+
                                            '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow-right"></use>'+
                                        '</svg>'+
                                    '</span>'+
                                '</a>'+
                            '{% endif %}'+

                            '<div class="pagination__content">'+
                                '<span class="pagination__current-page">{{data.currentPage}}</span>'+
                                '<span class="">{% if data.strOf is empty %} из {% else %} {{ data.strOf }} {% endif %} {{data.countAllPage}}</span>'+
                            '</div>'+

                            '{% if data.currentPage == data.countAllPage or data.countAllPage == 0 %}'+
                                '<div class="pagination__next disabled">'+
                                    '<span class="svg-icon">'+
                                        '<svg>'+
                                            '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow-right"></use>'+
                                        '</svg>'+
                                    '</span>'+
                                '</div>'+
                            '{% else %}'+
                                '<a href="?PAGEN_{{ data.navNum }}={{ data.currentPage + 1 }}{{  data.currParamsUrs }}" class="pagination__next" data-next-calendar-pagination="true">'+
                                    '<span class="svg-icon">'+
                                        '<svg>'+
                                            '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow-right"></use>'+
                                        '</svg>'+
                                    '</span>'+
                                '</a>'+
                            '{% endif %}'+
                        '</div>'
            });
        return template;
    }
}

$(document).ready(function($) {

    // Инициализируем поле поиска
    Events.initSearch();

    if($('[data-calendar-search-form]').length) {
        // Живой поиск
        LiveSearch.init();
    }

    // Инициализируем селект Тип мероприятия
    let selectCalendarEvents = $('[data-select-calendar-filter-events]');
    if(selectCalendarEvents.length) {
        Events.initSelect(selectCalendarEvents);
    }

    if ($('.calendar-list').length) {
        $(window).on('load:calendar', function(e, CalendarFilter) {
            EventsFilter.dateStart = CalendarFilter.dateStart;
            EventsFilter.dateFinish = CalendarFilter.dateFinish;

            if (EventsFilter.dateStart != '' && EventsFilter.dateFinish != '') {
                Events.clearSearch();
                $('[data-clear-filter-calendar-events]').addClass('show');
            }

            Events.ajaxFilter(true);
        })

        $(window).on('change:calendar', function(e, CalendarFilter) {

            // Если изменилось значение даты, то сбрасываем текущую страницу на 1
            currEventsListPage = 1;

            EventsFilter.dateStart = CalendarFilter.dateStart;
            EventsFilter.dateFinish = CalendarFilter.dateFinish;

            if (EventsFilter.dateStart != '' && EventsFilter.dateFinish != '') {
                Events.clearSearch();
                $('[data-clear-filter-calendar-events]').addClass('show');
            }
            Events.ajaxFilter();
        })
    }

    // Обрабатываем кнопку
    let btnShowMoreCalendar = $('[data-show-more-calendar]');
    if(btnShowMoreCalendar.length){

        // Если при загрузке страницы в гет-парметрах есть номер текущей страницы, то
        // записываем его в переменную currEventsListPage, если в гет-параметрах нет номера страницы,
        // по умолчанию устанавливается 1
        let paramsUrl = Events.getJsonFromUrl();

        if(paramsUrl['PAGEN_1']) {
            currEventsListPage = parseFloat(paramsUrl['PAGEN_1']);
        }

        btnShowMoreCalendar.on('click', function(e){
            e.preventDefault();
            Events.ajaxAddPage($(this));
        });
    }

    // При загрузке страницы, когда все проинициализировалось проверяем урл
    var $currPage = window.location.href;

    // для архивных ссылок вида /events/?dateStart=05-08-2019&dateFinish=05-09-2019
    if($('[data-calendar-list]').length && ($currPage.indexOf('events') > 0) && ($currPage.indexOf('dateStart') > 0) && ($currPage.indexOf('dateFinish') > 0)) {
        var paramsUrl = Events.getJsonFromUrl(),
            arrStartDate = paramsUrl.dateStart.split("-"),
            arrFinishDate = paramsUrl.dateFinish.split("-");

        Calendar.setDateDatepicker(new Date(arrStartDate[2], parseInt(arrStartDate[1]) - 1, arrStartDate[0]), new Date(arrFinishDate[2], parseInt(arrFinishDate[1]) - 1, arrFinishDate[0]));
        currParamsUrs = '&dateStart=' + paramsUrl.dateStart + '&dateFinish=' + paramsUrl.dateFinish;
        Calendar.setGlobalDate();

        if(paramsUrl.typeEvent) {
            selectCalendar.selectize()[0].selectize.setValue(paramsUrl.typeEvent);
            currParamsUrs = currParamsUrs + '&typeEvent=' + paramsUrl.typeEvent;
        }

        // Устанавливаем глобальные даты фильтрации календаря и обновляем список мероприятий
        var calendarDateVal = Calendar.getCalendarFilter();
        EventsFilter.dateStart = calendarDateVal.dateStart;
        EventsFilter.dateFinish = calendarDateVal.dateFinish;

        Events.clearSearch();
        $('[data-clear-filter-calendar-events]').addClass('show');
        EventsFilter.clearSearchText = 'Y';
        Events.ajaxFilter(true);
        setTimeout(function(){
            EventsFilter.clearSearchText = '';
        }, delayAjaxFilterEvents);
    }

    // Обработка кнопки очищения фильтра - кастомный метод для events
    let btnClearFilterCalendarEvents = $('[data-clear-filter-calendar-events]');
    btnClearFilterCalendarEvents.on('click', function(){
        // Устанавливаем для типа мероприятия дефолтное значение, а при изменении значения
        // запускается аякс фильтрации
        let selectCalendar = $('[data-select-calendar-filter-events]');

        if (selectCalendar.length) {
            var optionsSelectizeTypeEvent = selectCalendar.selectize()[0].selectize.options;
            for (var key in optionsSelectizeTypeEvent) {

                var firstOptionValue = optionsSelectizeTypeEvent[key].value;
                selectCalendar.selectize()[0].selectize.setValue(firstOptionValue);

                break;
            }
        }

        Calendar.clearCalendar();
        $('[data-clear-filter-calendar-events]').removeClass('show');

        // При очищении фильтра, если указывали гет-параметры, то перезагружаем страницу
        if(currParamsUrs.length) {
            isClickClearWithParams = true;
        }else {
            $('[data-content-calendar]').removeClass('filter');
        }
    });

    let $liveSearchFilter = $('[data-live-search-filter]');
    if($liveSearchFilter.length) {
        EventsLiveSearchOptions.section = $liveSearchFilter.data('live-search-filter');

        let $eventsLiveSearch = $('[data-calendar-search-form]').find('[data-live-search]');
        if($eventsLiveSearch.length) {
            $eventsLiveSearch.data('live-search-options', JSON.stringify(EventsLiveSearchOptions));
        }
    }

})


// WEBPACK FOOTER //
// ./pages/events.js